function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.687,
  y: 16,
  width: 16,
  height: 16,
  rx: 1,
  transform: "rotate(-45 4.687 16)",
  fill: "#2DB35C"
});

var SvgIconDiamondActive = function SvgIconDiamondActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxyZWN0IHg9IjQuNjg2NTIiIHk9IjE2IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNC42ODY1MiAxNikiIGZpbGw9IiMyREIzNUMiLz4KPC9zdmc+Cg==";
export { SvgIconDiamondActive as ReactComponent };